import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { TOOLTIP_DIR_TYPE_VALUE } from '@typings/common/tooltipDirType';

import TooltipContents from './TooltipContents';
import PortalTooltip from './PortalTooltip';
import { scrollbarHide } from '@styles/variants/scrollbar';

const Container = styled(motion.div)`
  position: relative;
  display: inline-block;

  ${scrollbarHide}
`;

interface Props {
  children: JSX.Element | JSX.Element[] | string;
  message?: JSX.Element | string;
  direction?: TOOLTIP_DIR_TYPE_VALUE;
  hidden?: boolean;
  isPortal?: boolean;
  maxWidth?: string;
}

function Tooltip({
  children,
  message,
  direction = 'top',
  hidden,
  isPortal = false,
  maxWidth,
}: Props) {
  const [hovered, setHovered] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  if (hidden) return <>{children}</>;

  return (
    <Container
      onMouseEnter={(e) => {
        setHovered(true);
      }}
      onMouseMove={(e) => {
        // if (!hovered) return;
        setPosition({ x: e.clientX, y: e.clientY });
      }}
      onMouseLeave={() => setHovered(false)}
    >
      {/* stacking context 방지: tooltip은 포털에서 렌더 */}
      {children}
      <AnimatePresence>
        {message && (
          <>
            {isPortal ? (
              <PortalTooltip visible={hovered} position={position}>
                <TooltipContents
                  direction={direction}
                  visible={hovered}
                  position={position}
                  noArrow={true}
                  maxWidth={maxWidth}
                  style={{ position: 'fixed' }}
                >
                  {message}
                </TooltipContents>
              </PortalTooltip>
            ) : (
              <TooltipContents
                noArrow={false}
                direction={direction}
                visible={hovered}
                maxWidth={maxWidth}
              >
                {message}
              </TooltipContents>
            )}
          </>
        )}
      </AnimatePresence>
    </Container>
  );
}

export default Tooltip;
